
import { Component, Vue, Prop } from 'vue-property-decorator'
import { getUrlFileName } from '../utils/tool'
import instance from '@/service'
import {
  getToken,
  removeToken,
  getUserName,
  getUserPortrait,
  getUserRole,
  getIdCardNo,
  getManual,
  getUserPhone,
  removeUserName,
  removeUserPortrait,
  removeUserRole,
  removeIdCardNo,
  removeManual
} from '../utils/cookies'
import { Menu, MenuItem, Popover, Submenu } from 'element-ui'
import { menuList, menuEnterpriseList } from '../commons/menus'
import { Config } from '@/pages/index/services/HomeService'
import { LoginUserType } from '@/commons/enums'
import { OnlyShowLogoConfigModuleKey } from '@/config-center'
import DialogPage from './course-item/dialog.vue'
import AboutUs from './AboutUs.vue'
import Download from './Download.vue'
import MobileMenu from './MobileMenu.vue'
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Popover)
Vue.use(Submenu)
@Component({
  components: {
    DialogPage,
    AboutUs,
    Download,
    MobileMenu
  }
})
export default class HorizontalMenu extends Vue {
  // private logo = localStorage.getItem('logo') ? localStorage.getItem('logo') : ''
  private logo = ''
  private activeUrl = 'index.html'
  private showTitle = true
  private diffBgColor = false
  private organizationTitle = ''
  // private organizationTitle = localStorage.getItem('organizationTitle') ? localStorage.getItem('organizationTitle') : ''
  private menuList = localStorage.getItem('type') === 'enterprise' && getToken() ? menuEnterpriseList : menuList

  private userName = getUserName() ? getUserName() : '游客'
  private userPhone = getUserPhone()
  private userPortrait = getUserPortrait() ? getUserPortrait() : require('../assets/images/study.jpg')
  private isCertified = JSON.parse(localStorage.getItem('isCertified') as string)
  private idCardNo = getIdCardNo()
  private manualPath = getManual()
  private isHavetoken = false
  private loginUserType = localStorage.getItem('type')
  private isEnterprise = this.loginUserType === LoginUserType.Enterprise
  private submenus = []
  private showChild = false
  private isMobile = false
  private backLogin = function () {
    localStorage.clear()
    removeToken()
    removeUserName()
    removeUserRole()
    removeUserPortrait()
    removeManual()
    removeIdCardNo()
    window.location.href = '/login.html'
  }

  private dialogVisible = false
  private dialogUs = false
  private download = false
  // styleChange () {
  //   if ( window.location.href === ('/index.html/#')) {
  //   }
  // }

  // 首页
  homeJump () {
    window.location.href = ('/index.html/#')
  }

  // 资讯
  toInformation () {
    window.location.href = (`/news.html#/${process.env.VUE_APP_INDUSTRY_ID}/行业动态`)
  }

  showPolicies () {
    window.location.href = (`/news.html#/${process.env.VUE_APP_POLICY_ID}/政策法规`)
  }

  trainingcenter () {
    // window.location.href = ('/study.html#/')
    // TODO
    window.location.href = '/infoNews.html#/news/1407979304161845248/新职业介绍'
  }

  certification () {
    window.location.href = '/searchCertificate.html'
  }

  // 关于我们
  aboutUs () {
    // window.location.href = ('/aboutUs.html')
    // TODO:
    window.location.href = '/infoNews.html#/news/1407981503742943232/关于我们'
  }

  // 学习中心
  learningcenter () {
    window.location.href = ('/study.html#/')
  }

  // 考试中心
  learningClick () {
    window.location.href = 'https://web.chinahrt.com/caceelogin.html'
  }

  // 证书
  certifiCate (): void {
    window.open('http://cert.chinahrt.com/#/')
  }

  get hasCertifyBtn () {
    return !this.isCertified && this.isHavetoken && !this.isEnterprise
  }

  private currentUrl = getUrlFileName().split('?')[0]
  private gotoInfoDetail (menuId: string, menuName: string) {
    console.log(this.currentUrl)
    if (this.currentUrl === 'infoNews.html#') {
      window.location.href = `/infoNews.html#/${menuId}/${menuName}`
      window.location.reload()
    } else {
      window.location.href = `/infoNews.html#/${menuId}/${menuName}`
      console.log(window.location.href)
    }
  }

  private handleSelect = (url: string) => {
    if (this.currentUrl === 'courseDetailVideo.html') {
      this.$emit('gotoMenuItem', () => {
        window.location.href = `/${url}`
      })
    } else {
      if (url === 'infoNews.html#') {
        // window.location.href = `/${url}/`
        // this.showChild = true
      } else {
        window.location.href = `/${url}`
      }
    }
  }
  // private gotoPersonal = function () {
  //   console.log(localStorage.getItem('type'))
  //   if (localStorage.getItem('type') === 'enterprise') {
  //     window.location.href = 'home.html'
  //     return
  //   }
  //   if (getUserRole() === 'guild') {
  //     window.location.href = 'myStudy.html'
  //   } else {
  //     window.location.href = 'learningPlan.html'
  //   }
  // }

  private filterPropNameGetValue (list: any, moduleName: string) {
    const filteredList = list.filter((item: any) => {
      return item.moduleName === moduleName
    })
    return filteredList[0]
  }

  private filtermoduleKeyGetValue (list: any, moduleKey: string) {
    const filteredList = list.filter((item: any) => {
      return item.moduleKey === moduleKey
    })
    if (!filteredList || !filteredList[0]) {
      return ''
    }
    return filteredList[0].moduleValue
  }

  async setLogo () {
    const logoConfig = await new Config().gethomeConfigService('S003')
    this.logo = this.filtermoduleKeyGetValue(this.filterPropNameGetValue(logoConfig, 'organization_logo').properties, 'organization_logo')
    // localStorage.setItem('logo', JSON.stringify(this.logo))
    this.organizationTitle = (localStorage.getItem('organizationTitle') as string)
  }

  private async getZixunMenuChild () {
    const res = await instance.get('/api/v1/menu/homePage/')
    if (res && res.data && res.data.items) {
      // this.submenus = res.data.items
      console.log('items', res.data.items)
      const home = menuList[0]
      const submenus = menuList.slice(1)
      console.log('submenus', submenus)
      let arr = res.data.items.map((item: any) => {
        return {
          title: item.name,
          url: `infoNews.html#/${item.id}/${item.name}`
        }
      })
      arr.unshift(home)
      arr = arr.concat(submenus)
      this.menuList = arr
    }
  }

  // private async isShowTitle () {
  //   const key = OnlyShowLogoConfigModuleKey
  //   const result = await instance.get(`/api/v1/admin/organizations/openKey/?key=${key}`)
  //   const item = result.data[0]
  //   let bl = true
  //   if (!item) {
  //     bl = true
  //   } else {
  //     bl = item.value === 'true'
  //   }
  //   this.showTitle = bl
  // }

  private hoverMenu (name: string) {
    if (name === '资讯') {
      this.showChild = true
    }
  }

  private removehoverMenu (name: string) {
    if (name === '资讯') {
      this.showChild = false
    }
  }

  judgeIsMobile () {
    const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    console.log('flag: ', flag)
    if (flag) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  }

  async mounted () {
    this.judgeIsMobile()
    if (getToken()) {
      this.isHavetoken = true
    } else {
      this.isHavetoken = false
    }
    // this.isShowTitle()
    this.getZixunMenuChild()
    menuList.forEach((item, i) => {
      if (item.title === '个人中心' && !getToken()) {
        menuList.splice(i, 1)
      }
      if (item.title === '个人中心' && getToken() && getUserRole() === 'guild') {
        item.url = 'myStudy.html'
      }
    })
    let activeUrl = ''
    // 个人中心下的页面需在这里添加上文件名，默认选中
    if (getUrlFileName() === 'myStudy.html#' ||
      getUrlFileName() === 'myOrder.html' ||
      getUrlFileName() === 'learningRecord.html' ||
      getUrlFileName() === 'setting.html#' ||
      getUrlFileName() === 'myCertificate.html') {
      activeUrl = 'learningPlan.html#'
    } else {
      if (window.location.href.split('?') && window.location.href.split('?')[1]) {
        if (window.location.href.split('?')[1] === 'type=featuresEnterprise') {
          activeUrl = 'featuresEnterprise.html'
        }
      } else {
        activeUrl = getUrlFileName()
      }
    }
    this.activeUrl = activeUrl
    this.setLogo()
  }

  certify () {
    window.location.href = '/userCertification.html'
  }

  manual () {
    const url = this.manualPath
    window.open(url, '__blank')
  }
}
